import { useContext } from 'react'

import { AutocompleteContext } from './context'
import { Portal } from '../Portal'

interface AutocompleteEmptyMessageProps {
  children: React.ReactNode;
}

export function AutocompleteStatus ({ children }: AutocompleteEmptyMessageProps) {
  const { statusElement } = useContext(AutocompleteContext)

  return (
    <div className='py-1 px-2 text-gray-500 body'>
      <span aria-hidden>{children}</span>
      {statusElement && <Portal container={statusElement}>{children}</Portal>}
    </div>
  )
}

AutocompleteStatus.displayName = 'Autocomplete.Status'
